function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    rmINoBounceHelper.enable();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      rmINoBounceHelper.disable();
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    rmINoBounceHelper.enable();
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.rmUpdateElements();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  rmUpdateElements() {
    const inStockElem = document.querySelector('.rm-product-single-in-stock');
    const oosElem = document.querySelector('.rm-product-single-oos');
    const deliveryTimer = document.querySelector('.rm-delivery-timer');
    const mhraId = document.querySelector('.rm-product-mhra-id');
    const currVariantQty = parseInt(rmVariantQuantities[this.currentVariant.id]);

    if (currVariantQty < 1) {
      inStockElem.classList.remove('rm-shown-flex');
      deliveryTimer.classList.remove('rm-shown-flex');
      oosElem.classList.add('rm-shown-flex');
    } else {
      oosElem.classList.remove('rm-shown-flex');
      inStockElem.classList.add('rm-shown-flex');
      deliveryTimer.classList.add('rm-shown-flex');
    }

    if(mhraId != null) {
      var url = `${this.dataset.url}?view=variant-metafields.json`;
      fetch(url)
        .then((response) => response.text())
        .then((body) => {
          let metafields = JSON.parse(body.trim())
          if(typeof metafields[this.currentVariant.id]['mhra_id'] != undefined) {
            if(metafields[this.currentVariant.id]['mhra_id'] != '') {
              mhraId.style.display = 'block'
              mhraId.querySelector('.rm-product-mhra-id-value').innerHTML = metafields[this.currentVariant.id]['mhra_id']
            } else {
              mhraId.style.display = 'none'
              mhraId.querySelector('.rm-product-mhra-id-value').innerHTML = ''
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.rmUpdateAddToCartForm(this.currentVariant.available);
      });
  }

  rmUpdateAddToCartForm(variantAvailable) {

    const currVariantQty = parseInt(rmVariantQuantities[this.currentVariant.id]);
    const paymentButton = document.querySelector('.rm-shopify-payment-button-wrapper');
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (currVariantQty < 1) {
      paymentButton && paymentButton.classList.add('hidden');
      addButtonText.textContent = variantAvailable ? window.variantStrings.rmBackOrder : window.variantStrings.soldOut;
    } else {
      paymentButton && paymentButton.classList.remove('hidden');
    }

  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Real Media

class RmCollapseBtn extends HTMLElement {
  constructor() {
    super();

    this.featuredBrandRetailerSect = document.querySelector('.rm-featured-brand-banner-retailer-wrap');
    this.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const content = this.dataset.target != null ? document.querySelector(this.dataset.target) : this.nextElementSibling;
    const collapseBtn = this.querySelector('.rm-seo-content-btn-top');

    if (content.style.maxHeight){
      content.style.maxHeight = null;
      collapseBtn.classList.remove('rm-seo-content-btn-top--active');
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      collapseBtn.classList.add('rm-seo-content-btn-top--active');
    } 

    if (this.featuredBrandRetailerSect) {
      this.featuredBrandRetailerSect.classList.toggle('rm-mt-1-5');
    }

  }

}

customElements.define('rm-collapse-btn', RmCollapseBtn);

class RmCollapseBtnBot extends HTMLElement {
  constructor() {
    super();

    this.scrollYOffset = window.screen.width > 767 ? 0 : -92; // Account for sticky header on mobile

    this.sectionWrap = this.parentElement;
    this.toggleBtn = this.querySelector('.rm-seo-content-btn-bot');
    this.addEventListener('click', this.toggleCollapse);
  }



  toggleCollapse() {
    const sectionLoc = this.sectionWrap.getBoundingClientRect().top + window.scrollY + this.scrollYOffset;
    const content = this.previousElementSibling;
    const seoText = content.querySelector('.rm-seo-content-bot-seo-text');
    seoText.classList.toggle('rm-seo-content-bot-seo-text--active');
    content.classList.toggle('rm-seo-content-text-wrap-bot--active');

    if (seoText.classList.contains('rm-seo-content-bot-seo-text--active')) {
      this.toggleBtn.textContent = 'Less';
    } else {
      this.toggleBtn.textContent = 'More';
    }

    window.scrollTo({top: sectionLoc, behavior: 'auto'});
  }

}

customElements.define('rm-collapse-btn-bot', RmCollapseBtnBot);

class RmCollapseBtnAboutUs extends HTMLElement {
  constructor() {
    super();

    this.toggleBtn = this.querySelector('.rm-about-us-more');
    this.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const additionalContent = this.previousElementSibling;
    additionalContent.classList.toggle('rm-about-us-content-additional--active');

    if (additionalContent.classList.contains('rm-about-us-content-additional--active')) {
      this.toggleBtn.textContent = 'Less';
    } else {
      this.toggleBtn.textContent = 'More';
    }
  }

}

customElements.define('rm-collapse-btn-about-us', RmCollapseBtnAboutUs);

class RmCollapsibleFaq extends HTMLElement {
  constructor() {
    super();

    // These classes come from custom fields. For each card we paste the markup in the code editor. 
    // Reason: There is no way to set the title separately and still remain flexible with the number of cards they can add.
    this.toggleBtn = this.querySelector('.rm-collapsible-faq-card-btn');
    this.content = this.querySelector('.rm-collapsible-faq-card-txt');

    if (this.toggleBtn && this.content) {
      this.addEventListener('click', this.toggleCollapse.bind(this));
    }
  }

  toggleCollapse() {
    this.content.classList.toggle('rm-collapsible-faq-card--active');
  }

}

customElements.define('rm-collapsible-faq', RmCollapsibleFaq);

class RmCollapseBtnFooter extends HTMLElement {
  constructor() {
    super();

    this.parentElement.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const content = this.nextElementSibling;
    content.classList.toggle('rm-footer-block--active');
  }

}

customElements.define('rm-collapse-btn-footer', RmCollapseBtnFooter);

// TODO Refactor and merge these into one class
class RmCollapseBtnBlogSeo extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const seoText = this.previousElementSibling;
    const btnText = this.querySelector('.rm-blog-seo-expand-btn-txt');
    seoText.classList.toggle('rm-blog-seo-text--active');
    this.classList.toggle('rm-blog-seo-btn--active')

    if (seoText.classList.contains('rm-blog-seo-text--active')) {
      btnText.textContent = 'Less';
    } else {
      btnText.textContent = 'More';
    }
  }

}

customElements.define('rm-collapse-blog-seo', RmCollapseBtnBlogSeo);

class RmAdBanners extends HTMLElement {
  constructor() {
    super();

    // TODO Add event tracking for Google Analytics
  }

}

customElements.define('rm-ad-banners', RmAdBanners);

class RmProductLabel extends HTMLElement {
  constructor() {
    super();

    this.now = new Date();
    this.label = this.dataset.label;
    this.expiry = this.dataset.expiry;
    this.createdAt = new Date(this.dataset.created);
    this.autoExpirationDate = this.addDaysToDate(this.createdAt, parseInt(this.dataset.autoExpirationDays));

    // Newly added products don't have the label and expiration set
    this.isNew = (this.label === '' && this.expiry === '') && (this.now < this.autoExpirationDate);

    if (this.isNew) {
      this.setAsNew();
      this.showLabel();
    }

    // We use js for this instead of liquid as the date can be unreliable in liquid due to caching
    this.expired = this.now > new Date(this.expiry);

    if (!this.expired) {
      this.showLabel()
    }
  }

  addDaysToDate(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  showLabel() {
    this.style.display = 'inline-flex';

    if (this.label !== '') {
      this.parentElement.classList.add('rm-product-label-on');
      this.textContent = this.dataset.label;
      if (this.dataset.product) {
        this.classList.add('rm-product-label-product--' + this.dataset.handleizedLabel);
      } else {
        this.classList.add('rm-product-label--' + this.dataset.handleizedLabel);
      }
    }
  }

  setAsNew() {
    this.textContent = 'New';
    this.classList.add('rm-product-label--new');
  }

};

customElements.define('rm-product-label', RmProductLabel);

class RmContentSlider {
  constructor(selector, breakpoints, initialWidth) {

    this.sectionGliders = document.querySelectorAll(selector);

    this.addEventListeners()
    this.initGlider(breakpoints, initialWidth);
  }

  initGlider(breakpoints, initialWidth) {
    this.sectionGliders.forEach(function (ele) {
      new Glider(ele, {
        slidesToShow: 'auto',
        slidesToScroll: 1,
        itemWidth: initialWidth ? initialWidth : 'auto',
        exactWidth: initialWidth ? true : false,
        scrollLock: true,
        draggable: false,
        dots: ele.parentNode.querySelector('.dots'),
        arrows: {
          prev: ele.parentNode.querySelector('.glider-prev'),
          next: ele.parentNode.querySelector('.glider-next')
        },
        responsive: breakpoints ? breakpoints : []
      });
    });
  }

  addEventListeners() {
    this.sectionGliders.forEach(function (section) {
      section.addEventListener('glider-loaded', function() {
        section.closest('.rm-content-slider').style.visibility = 'visible';
      })
    });

    // document.addEventListener('glider-loaded', this.hideFFScrollBars);
    // document.addEventListener('glider-refresh', this.hideFFScrollBars);
  }

  hideFFScrollBars(e){
    const scrollbarHeight = 17; // Currently 17, may change with updates
    if(/firefox/i.test(navigator.userAgent)){
      // We only need to apply to desktop. Firefox for mobile uses
      // a different rendering engine (WebKit)
      if (window.innerWidth > 575){
        e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px';
      }
    }
  }

}

class RmFloatingFilterBtn extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Menu drawer dependency
    this.facetsMenuDrawer = document.querySelector('.mobile-facets__wrapper');

    this.productContainer = document.getElementById('AjaxinateContainer');

    this.addEventListener('click', this.facetsMenuDrawer.onSummaryClick.bind(this.facetsMenuDrawer));
    document.addEventListener("scroll", this.showOrHideBtn.bind(this));

    this.showOrHideBtn()
  }

  showOrHideBtn() {
    const currFacetsMenuLocation = this.facetsMenuDrawer.getBoundingClientRect().top + window.scrollY;
    const productContainerBotLoc = this.productContainer.getBoundingClientRect().bottom + window.scrollY;
    if (window.scrollY > (currFacetsMenuLocation + 48) && window.scrollY < productContainerBotLoc) {
      this.classList.add("rm-floating-filterbtn--show");
    } else {
      this.classList.remove("rm-floating-filterbtn--show");
    }
  }

}

customElements.define('rm-floating-filter', RmFloatingFilterBtn);

class RmHamburgerMenuCloseExtension extends HeaderDrawer {
  constructor() {
    super();

    this.headerDrawer = document.querySelector('header-drawer');
    this.headerSummary = this.headerDrawer.querySelector('summary');

    this.addEventListener('click', this.closeHamburgerMenu)

  }

  closeHamburgerMenu() {
    this.headerDrawer.closeMenuDrawer(this.headerSummary);
  }

}

customElements.define('rm-hamburger-close', RmHamburgerMenuCloseExtension);

class rmINoBounceHelper {

  static isIOS() {
    return /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
  }

  static enable() {
    if (!iNoBounce.isEnabled() && rmINoBounceHelper.isIOS()) {
      console.log('Enabling iNoBounce...');
      iNoBounce.enable();
    }
  }

  static disable() {
    if (iNoBounce.isEnabled() && rmINoBounceHelper.isIOS()) {
      console.log('Disabling iNoBounce...');
      iNoBounce.disable();
    }
  }

}